import { render, staticRenderFns } from "./TextDisplayList.vue?vue&type=template&id=38a3461e&"
import script from "./TextDisplayList.vue?vue&type=script&lang=js&"
export * from "./TextDisplayList.vue?vue&type=script&lang=js&"
import style0 from "./TextDisplayList.vue?vue&type=style&index=0&id=38a3461e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports